export default __webpack_public_path__ + "static/media/mahjong.4ff6dc07.mp3";